var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1661 12.5757C22.5168 12.272 22.5168 11.728 22.1661 11.4243L13.8096 4.18736C13.3164 3.7602 12.5495 4.11057 12.5495 4.76306L12.5495 7.75687C9.39301 7.75687 2.78716 9.40524 2.00133 18.2518C1.97403 18.5591 2.37474 18.7364 2.61199 18.5393C4.20909 17.2124 7.66842 15.3685 12.5495 15.5903L12.5495 19.2369C12.5495 19.8894 13.3164 20.2398 13.8096 19.8126L22.1661 12.5757Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.54847cf87c334a673da6034e7902bbe0.svg";
export { ForwardRef as ReactComponent };